// extracted by mini-css-extract-plugin
module.exports = {"timePill":"TimePill_timePill__SQBaD","input":"TimePill_input__hoI8g","label":"TimePill_label__pWa8C"};